import { useState, useEffect, useCallback, useRef } from "react";
import { supabase } from "@/lib/supabase";

export interface RedSocialData {
  id: number;
  nombre: string;
  url: string;
  icono: string;
  color_class: string;
  orden: number;
}

export function useRedesSociales(fallback: RedSocialData[] = []) {
  const fallbackRef = useRef(fallback);
  fallbackRef.current = fallback;

  const [data, setData] = useState<RedSocialData[]>(fallbackRef.current);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const mounted = useRef(true);

  const fetchData = useCallback(async () => {
    if (!mounted.current) return;
    setLoading(true);
    setError(null);
    try {
      const { data: result, error: err } = await supabase
        .from("redes_sociales")
        .select("*")
        .order("orden", { ascending: true });
      if (err) throw err;
      if (mounted.current) {
        setData((result as RedSocialData[]) ?? fallbackRef.current);
      }
    } catch {
      if (mounted.current) {
        setError("Error cargando redes sociales");
        setData(fallbackRef.current);
      }
    } finally {
      if (mounted.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    fetchData();
    return () => {
      mounted.current = false;
    };
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}